import axios from 'axios'
export const api = axios.create({ baseURL: 'https://hongxapi.dashitongxin.cn/api' })

export function errorMessage(err) {
  if (err && err.response) return `接口错误 ${err.response.status}：${err.response.data && err.response.data.message ? err.response.data.message : '请检查后端服务和数据库表'}`
  return '接口不可用：请确认后端已启动并可访问 /api'
}
